"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var styled_components_1 = __importStar(require("styled-components"));
var Fade = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tdisplay: flex;\n\tposition: fixed;\n\ttop: 0;\n\tbottom: 0;\n\tleft: 0;\n\tright: 0;\n\toverflow-y: auto;\n\t\n\tbackground-color: rgba(0, 0, 0, 0.5);\n\tpointer-events: auto;\n\n\t@media ", " {\n\t\t@supports (-webkit-overflow-scrolling: touch){\n\t\t\t-webkit-overflow-scrolling: touch;\n\t\t}\n\t}\n\n\t", "\n"], ["\n\tdisplay: flex;\n\tposition: fixed;\n\ttop: 0;\n\tbottom: 0;\n\tleft: 0;\n\tright: 0;\n\toverflow-y: auto;\n\t\n\tbackground-color: rgba(0, 0, 0, 0.5);\n\tpointer-events: auto;\n\n\t@media ", " {\n\t\t@supports (-webkit-overflow-scrolling: touch){\n\t\t\t-webkit-overflow-scrolling: touch;\n\t\t}\n\t}\n\n\t", "\n"])), function (props) { return props.theme.breakpoints.S; }, function (props) { return props.theme.fade; });
var Fader = /** @class */ (function (_super) {
    __extends(Fader, _super);
    function Fader(props) {
        var _this = _super.call(this, props) || this;
        _this.onMouseDownCapture = function (e) {
            _this.ignoreClick = (e.currentTarget !== e.target);
        };
        _this.onClick = function (e) {
            e.stopPropagation();
            e.preventDefault();
            if (!_this.ignoreClick) {
                if (document.elementFromPoint(e.clientX, e.clientY) === e.nativeEvent.target) {
                    _this.props.onClick();
                }
            }
        };
        _this.ignoreClick = false;
        return _this;
    }
    Fader.prototype.render = function () {
        return (react_1.default.createElement(Fade, { id: "fade", onMouseDownCapture: this.onMouseDownCapture, onClick: this.onClick }, this.props.children));
    };
    Fader.propTypes = {
        onClick: prop_types_1.default.func,
        children: prop_types_1.default.node
    };
    Fader.defaultProps = {};
    return Fader;
}(react_1.Component));
exports.default = styled_components_1.withTheme(Fader);
var templateObject_1;
//# sourceMappingURL=Fader.js.map